import React, { Component } from 'react';

import Dialog from '../../../raven/modals/dialog';
import MEventView from './eventView';

import moment from 'moment';

export default class EventHistoryModal extends Component {

    constructor(props) {
        super(props);

        this.prefix1 = process.env.REACT_APP_KLOUD_API_BASE_URL + 'query/';
        this._unmounted = false;
        
        this.state = {
            events: [],
            loading: true,
        };
    }


    getRavenEvents = (date) => {
        // perform ajax calls to get it the next state
        let url = "" + this.prefix1 + "ajaxbig"
            + "?stage=" + this.props.stage
            + "&type=events"
            + "&raven=" + this.props.raven.raven_id;

        if (date)
            url += '&end=' + date;

        this.props.dataStore.queryLoop(url, (items) => {
            if (this._unmounted === true) return; // modal closed before data returned
            console.debug("Raven events data:", items);

            if (!(items && items.length > 0)) {
                console.debug("No more data?");
                this.setState({ loading: false });
                return;
            } else {
                if (this.state.events.length > 0) {
                    this.setState({ events: [...this.state.events, ...items], loading: false });
                } else {
                    this.setState({ events: items, loading: false });
                }
            }
        });
    }

    loadMoreData = () => {
        let mindate = moment(this.state.events[0].ts).unix();
        let maxdate = moment(this.state.events[this.state.events.length - 1].ts).unix();
        console.debug("Load more data requested", mindate < maxdate ? mindate : maxdate);
        
        this.getRavenEvents(mindate < maxdate ? mindate : maxdate);
    }

    queryEventData() {
        console.log("Requesting for events");
        this.getRavenEvents();
    }

    componentDidMount() {
        this.queryEventData();
    }

    componentWillUnmount() {
        this._unmounted = true;
    }

    componentDidUpdate(prevProps, prevState) {

        if (this.props.raven && this.props.raven.item && this.props.raven.item.Id) {
            if (this.props.raven.item.Id !== prevProps.raven.item.Id) {
                console.debug("Raven item changed");
                this.queryEventData();
            }
        }
    }

    render() {

        return (
            <Dialog
                size="medium"
                className="test"
                label={this.props.title}
                isOpen={this.props.isOpen}
                onClose={this.props.onClose}
            >
                <div >
                    <div className="row">
                        <div className="col-12">
                            {this.state.events && !this.state.loading ?
                                this.state.events.length !== 0 ?
                                    <MEventView
                                        data={this.state.events}
                                        loading={this.state.loading}
                                        requestMoreData={this.loadMoreData}
                                    /> :
                                    <p>No Event Data...</p> :
                                <p>Loading...</p>
                            }
                        </div>
                    </div>

                </div>
            </Dialog>
        );
    }

}
